import { Card, CardBody } from 'reactstrap'
import Footer from './Footer'
import TextEditor from '../../TextEditor/index.js'
import { useDispatch } from 'react-redux'
import { setJobProp } from 'store/Recruitment/actions'
import { useSelector } from 'react-redux'

const textEditorOptions = {
  buttonList: [
    ['font', 'fontSize', 'formatBlock', 'list', 'fontColor'],
    ['fontColor', 'hiliteColor', 'align', 'list'],
    ['bold', 'underline', 'italic'],
  ],
  styles: `
  .my-editor .se-wrapper-inner .se-editable {
    border-radius: 90px;
  }
  `,
}

function ThirdSlide() {
  const dispatch = useDispatch()

  const { jobProps } = useSelector((store) => store.recruitment)

  return (
    <Card>
      <CardBody className='d-flex' style={{ gap: '2rem' }}>
        <div className='w-50'>
          <p className='title mb-2'>
            Job Description <span className='text-danger'>*</span>
          </p>
          <TextEditor
            key={'description'}
            placeholder='Write Here...'
            setOptions={textEditorOptions}
            textContent={
              jobProps?.find((el) => el?.name === 'description')?.value ?? ''
            }
            onChangeText={(e) =>
              dispatch(setJobProp({ value: e, name: 'description' }))
            }
          />
        </div>
        <div className='w-50'>
          <p className='title mb-2'>
            Job Requirement <span className='text-danger'>*</span>
          </p>
          <TextEditor
            key={'requirements'}
            placeholder='Write Here...'
            setOptions={textEditorOptions}
            textContent={
              jobProps?.find((el) => el?.name === 'requirements')?.value ?? ''
            }
            onChangeText={(e) =>
              dispatch(setJobProp({ value: e, name: 'requirements' }))
            }
          />
        </div>
      </CardBody>
      <Footer />
    </Card>
  )
}

export default ThirdSlide
